import { defineMessages, useIntl } from 'react-intl';
import { useSiteData } from 'modules/hooks';

export interface ChoiceType {
  name: string;
  value: string;
}

const useSc8DropDownChoices = () => {
  const intl = useIntl();
  const siteData = useSiteData();
  const isPtBr = siteData.cultureCode === 'pt-BR';

  const categoryChoices: ChoiceType[] = [
    {
      name: intl.formatMessage(messages.billing), // Payments/Subscription
      value: isPtBr ? 'pagamentos_e_cobranca' : 'pagos_y_cobranzas',
    },
    {
      name: intl.formatMessage(messages.accountSettings), // Account Settings
      value: isPtBr ? 'configuracao_da_conta' : 'configuraciones_de_cuenta',
    },
    {
      name: intl.formatMessage(messages.communicationsAndMessages), // Communications & Messages
      value: isPtBr ? 'comunicacao_e_mensagens' : 'comunicacion_y_mensajes',
    },
    {
      name: intl.formatMessage(messages.safetyAndPrivacy), // Safety and Privacy
      value: isPtBr ? 'seguranca_e_privacidade' : 'seguridad_y_privacidad',
    },
    {
      name: intl.formatMessage(messages.myProfile), // My Profile
      value: isPtBr ? 'meu_perfil' : 'mi_perfil',
    },
  ];

  const deviceChoices: ChoiceType[] = [
    {
      name: intl.formatMessage(messages.iosApp),
      value: `ios`,
    },
    {
      name: intl.formatMessage(messages.androidApp),
      value: `android`,
    },
    {
      name: intl.formatMessage(messages.mobileDevice),
      value: `navegador_do_celular`,
    },
    {
      name: intl.formatMessage(messages.desktopDevice),
      value: `computador`,
    },
  ];

  return {
    categoryChoices,
    deviceChoices,
  };
};

export default useSc8DropDownChoices;

const messages = defineMessages({
  iosApp: {
    id: 'src/modules/hooks/useSc8DropDownChoices:iosApp',
    description: 'dropdown selection for iOS App',
    defaultMessage: 'iOS App',
  },
  androidApp: {
    id: 'src/modules/hooks/useSc8DropDownChoices:androidApp',
    description: 'dropdown selection for Android App',
    defaultMessage: 'Android App',
  },
  mobileDevice: {
    id: 'src/modules/hooks/useSc8DropDownChoices:mobileDevice',
    description: 'dropdown selection for mobile device',
    defaultMessage: 'Mobile',
  },
  desktopDevice: {
    id: 'src/modules/hooks/useSc8DropDownChoices:desktopDevice',
    description: 'dropdown selection for desktop device',
    defaultMessage: 'Desktop',
  },
  accountSettings: {
    id: 'src/modules/hooks/useSc8DropDownChoices:accountSettings',
    description: 'dropdown selection for Account Settings',
    defaultMessage: 'Account Settings',
  },
  billing: {
    id: 'src/modules/hooks/useSc8DropDownChoices:billing',
    description: 'dropdown selection for Billing',
    defaultMessage: 'Payments/Subscription',
  },
  communicationsAndMessages: {
    id: 'src/modules/hooks/useSc8DropDownChoices:communicationsAndMessages',
    description: 'dropdown selection for Communications & Messages',
    defaultMessage: 'Communications & Messages',
  },
  safetyAndPrivacy: {
    id: 'src/modules/hooks/useSc8DropDownChoices:safetyAndPrivacy',
    description: 'dropdown selection for Safety & Privacy',
    defaultMessage: 'Safety & Privacy',
  },
  myProfile: {
    id: 'src/modules/hooks/useSc8DropDownChoices:myProfile',
    description: 'dropdown selection for My Profile',
    defaultMessage: 'My Profile',
  },
});
